import { RenewalNote } from '@policyvision/contracts';

import NoteCard from '@/common/components/card/NoteCard';

type GroupedNotes = Record<string, RenewalNote[]>;

type NotesListProps = {
  groupedNotes: GroupedNotes;
};

const RenewalNotesList = ({ groupedNotes }: NotesListProps) => (
  <>
    {Object.entries(groupedNotes).map(([dateKey, notes], index) => (
      <div key={`message-${dateKey}-${index}`} className="mb-6">
        <div className="flex justify-center mb-4">
          <span className="text-xs text-muted-foreground px-3 py-1 rounded-full">
            {dateKey}
          </span>
        </div>

        <div className="space-y-3">
          {notes.map((note) => (
            <NoteCard
              key={note.createdAt.toISOString()}
              createdAt={note.createdAt}
              createdByName={note.createdByName}
            >
              <p className="text-sm text-muted-foreground">{note.content}</p>
            </NoteCard>
          ))}
        </div>
      </div>
    ))}
  </>
);

export default RenewalNotesList;
